import service from '@/store/services/ordertest-service';

const state = {
    mainPhotoBlock: {},
    historyBlock: {},
    prevOrdersBlock: {},
    infoBlock: {},
    downtime: {},
    downloadExample: {},
    getNewOrder: {},
    submitOrder: {},
    submitComments: {},
    submitProblem: {},
    submitFile: {},
    whichRetoucher: {},
    writeRejected: {},
    countNewOrders: {}

};

const mutations = {
    SET_MAIN_PHOTO_BLOCK: (state, mainPhotoBlock) => {
        state.mainPhotoBlock = mainPhotoBlock;
    },
    SET_HISTORY_BLOCK: (state, historyBlock) => {
        state.historyBlock = historyBlock;
    },
    SET_PREV_ORDERS_BLOCK: (state, prevOrdersBlock) => {
        state.prevOrdersBlock = prevOrdersBlock;
    },
    SET_INFO_BLOCK: (state, infoBlock) => {
        state.infoBlock = infoBlock;
    },

    SET_DOWNTIME: (state, downtime) => {
        state.downtime = downtime;
    },
    SET_DOWNLOAD_EXAMPLE: (state, downloadExample) => {
        state.downloadExample = downloadExample;
    },
    SET_COUNT_NEW_ORDERS: (state, countNewOrders) => {
        state.countNewOrders = countNewOrders;
    },
    SET_GET_NEW_ORDER: (state, getNewOrder) => {
        state.getNewOrder = getNewOrder;
    },

    SET_SUBMIT_ORDER: (state, submitOrder) => {
        state.submitOrder = submitOrder;
    },

    SET_SUBMIT_COMMENTS: (state, submitComments) => {
        state.submitComments = submitComments;
    },

    SET_SUBMIT_PROBLEM: (state, submitProblem) => {
        state.submitProblem = submitProblem;
    },

    SET_SUBMIT_FILE: (state, submitFile) => {
        state.submitFile = submitFile;
    },

    SET_WHICH_RETOUCHER: (state, whichRetoucher) => {
        state.whichRetoucher = whichRetoucher;
    },
    SET_WRITE_REJECTED: (state,writeRejected ) => {
        state.writeRejected = writeRejected;
    },

};

const actions = {
    mainPhotoBlock({commit, dispatch}, params) {
        return service.mainPhotoBlock(params)
            .then(({mainPhotoBlock}) => {
                commit('SET_MAIN_PHOTO_BLOCK', mainPhotoBlock);
            });
    },
    historyBlock({commit, dispatch}, params) {
        return service.historyBlock(params)
            .then(({historyBlock}) => {
                commit('SET_HISTORY_BLOCK', historyBlock);
            });
    },
    countNewOrders({commit, dispatch}, params) {
        return service.countNewOrders(params)
            .then(({countNewOrders}) => {
                commit('SET_COUNT_NEW_ORDERS', countNewOrders);
            });
    },
    prevOrdersBlock({commit, dispatch}, params) {
        return service.prevOrdersBlock(params)
            .then(({prevOrdersBlock}) => {
                commit('SET_PREV_ORDERS_BLOCK', prevOrdersBlock);
            });
    },
    infoBlock({commit, dispatch}, params) {
        return service.infoBlock(params)
            .then(({infoBlock}) => {
                commit('SET_INFO_BLOCK', infoBlock);
            });
    },
    downtime({commit, dispatch}, params) {
        return service.downtime(params)
            .then(({downtime}) => {
                commit('SET_DOWNTIME', downtime);
            });
    },

    downloadExample({commit, dispatch}, params) {
        return service.downloadExample(params)
            .then(({downloadExample}) => {
                commit('SET_DOWNLOAD_EXAMPLE', downloadExample);
            });
    },
    getNewOrder({commit, dispatch}, params) {
        return service.getNewOrder(params)
            .then(({getNewOrder}) => {
                commit('SET_GET_NEW_ORDER', getNewOrder);
            });
    },
    submitOrder({commit, dispatch}, params) {
        return service.submitOrder(params)
            .then(({submitOrder}) => {
                commit('SET_SUBMIT_ORDER', submitOrder);
            });
    },
    submitComments({commit, dispatch}, params) {
        return service.submitComments(params)
            .then(({submitComments}) => {
                commit('SET_SUBMIT_COMMENTS', submitComments);
            });
    },
    submitProblem({commit, dispatch}, params) {
        return service.submitProblem(params)
            .then(({submitProblem}) => {
                commit('SET_SUBMIT_PROBLEM', submitProblem);
            });
    },
    submitFile({commit, dispatch}, params) {
        return service.submitFile(params)
            .then(({submitFile}) => {
                commit('SET_SUBMIT_FILE', submitFile);
            });
    },

    whichRetoucher({commit, dispatch}, params) {
        return service.whichRetoucher(params)
            .then(({whichRetoucher}) => {
                commit('SET_WHICH_RETOUCHER', whichRetoucher);
            });
    },

    writeRejected({commit, dispatch}, params) {
        return service.writeRejected(params)
            .then(({writeRejected}) => {
                commit('SET_WRITE_REJECTED', writeRejected);
            });
    },

};

const getters = {
    mainPhotoBlock: state => state.mainPhotoBlock,
    historyBlock: state => state.historyBlock,
    prevOrdersBlock: state => state.prevOrdersBlock,
    infoBlock: state => state.infoBlock,
    downtime: state => state.downtime,
    downloadExample: state => state.downloadExample,
    getNewOrder: state => state.getNewOrder,
    submitOrder: state => state.submitOrder,
    submitComments: state => state.submitComments,
    submitProblem: state => state.submitProblem,
    submitFile: state => state.submitFile,
    whichRetoucher : state => state.whichRetoucher,
    writeRejected : state => state.writeRejected,
    countNewOrders: state => state.countNewOrders,
};

const ordertest = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default ordertest;